const SESSION_IMU_NUOVO = 'imuSelezionato';

export {
  // eslint-disable-next-line import/prefer-default-export
  SESSION_IMU_NUOVO,
};
